var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoneyWheel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7399 8.67392H15.9954C15.8702 7.03512 15.2169 5.54189 14.2062 4.36377L10.4918 8.07815C10.6006 8.26204 10.6851 8.46204 10.7399 8.67392Z",
    fill: "#CCD6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61163 14.9584C4.78975 15.9691 6.28298 16.6224 7.92178 16.7476V11.4921C7.7099 11.4373 7.5099 11.3528 7.32601 11.244L3.61163 14.9584Z",
    fill: "#CCD6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4918 10.4263L14.2062 14.1407C15.2169 12.9625 15.8702 11.4693 15.9954 9.83051H10.7399C10.6852 10.0424 10.6006 10.2423 10.4918 10.4263Z",
    fill: "#CCD6F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50003 10.4088C9.13877 10.4088 9.65656 9.89096 9.65656 9.25223C9.65656 8.6135 9.13877 8.0957 8.50003 8.0957C7.8613 8.0957 7.34351 8.6135 7.34351 9.25223C7.34351 9.89096 7.8613 10.4088 8.50003 10.4088Z",
    fill: "#CCD6F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50818 10.4262C6.39935 10.2423 6.31485 10.0424 6.26011 9.83051H1.00458C1.12983 11.4693 1.78307 12.9625 2.7938 14.1407L6.50818 10.4262Z",
    fill: "#CCD6F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67397 11.244C9.49005 11.3528 9.29012 11.4374 9.07825 11.4921V16.7476C10.717 16.6224 12.2103 15.9691 13.3884 14.9584L9.67397 11.244Z",
    fill: "#CCD6F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50818 8.07815L2.7938 4.36377C1.78311 5.54189 1.12983 7.03512 1.00458 8.67392H6.26011C6.31485 8.46204 6.39935 8.26208 6.50818 8.07815Z",
    fill: "#CCD6F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07825 4.01981V7.01233C9.29012 7.06707 9.49009 7.15153 9.67397 7.2604L13.3884 3.54602C12.601 2.87053 11.6726 2.35495 10.6543 2.04974L9.07825 4.01981Z",
    fill: "#CCD6F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92178 7.01233V4.01981L6.3457 2.04974C5.32738 2.35499 4.39904 2.87053 3.61163 3.54602L7.32601 7.2604C7.50994 7.15161 7.7099 7.06707 7.92178 7.01233Z",
    fill: "#CCD6F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8131 0H6.18695L8.50001 2.89132L10.8131 0Z",
    fill: "#CCD6F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyWheel);
export default ForwardRef;